/**
 * This debouce func differs from lodash one: it returns a Promise that resolve
 * the latest call of the `inner` func. In contrary lodash's one is a sync
 * function that returns the result of the previous call. This does not work well
 * with FinalForm's validate pattern which can wait for the eventual error.
 * cf. https://stackoverflow.com/questions/35228052/debounce-function-implemented-with-promises
 */
export function debounce(
// $FlowFixMe[unclear-type]
inner, ms = 0
// $FlowFixMe[unclear-type]
) {
  let timer = null;
  let resolves = [];
  return function debounced(...args) {
    // reset timer to the next hop
    clearTimeout(timer);
    timer = setTimeout(() => {
      // Get the result of the inner function, then apply it to the resolve function of
      // each promise that has been created since the last time the inner function was run
      const result = inner(...args);
      resolves.forEach(r => {
        r(result);
      });
      resolves = [];
    }, ms);
    return new Promise(r => {
      resolves.push(r);
    });
  };
}